"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Forms/SendFormSheet.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _forms = require('shared/services/forms');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _store = require('web/store');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _controls = require('web/components/MessageTemplates/TemplatesDialog/controls');
var _FilledPage = require('./FilledPage'); var _FilledPage2 = _interopRequireDefault(_FilledPage);
require('./formsChat.scss');

















const FieldInput = ({ field, value, onChange }) => {
  const label = `${field.label || 'Untitled field'}${field.required ? '' : ' (optional)'}`
  if (field.type === 'checkbox') {
    return (
      _react2.default.createElement('label', { className: "forms-send--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
        , _react2.default.createElement('input', { type: "checkbox", checked: value === 'true', onChange: e => onChange(field.id, e.target.checked ? 'true' : ''), __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
        , label
      )
    )
  }
  if (field.type === 'choice' && _optionalChain([field, 'access', _ => _.options, 'optionalAccess', _2 => _2.length])) {
    return (
      _react2.default.createElement('select', { className: "forms-input", 'aria-label': label, value: value, onChange: e => onChange(field.id, e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        , _react2.default.createElement('option', { value: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, label)
        ,  field.options.map(option => _react2.default.createElement('option', { key: option, value: option, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}, option)) 
      )
    )
  }
  return (
    _react2.default.createElement('input', {
      className: "forms-input",
      type: "text",
      'aria-label': label,
      placeholder: label,
      value: value,
      onChange: e => onChange(field.id, e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
    )
  )
}

/* Send a form (screens 17 and 30): pick a published form, fill the staff
 * fields on the page preview, edit the message and send. The server adds
 * the link to the message. */
const SendFormSheet = ({ orgKey, conversationKey, recipientName, initialFormKey, onClose }) => {
  const [forms, setForms] = _react.useState(null)
  const [firstPages, setFirstPages] = _react.useState({})
  const [listError, setListError] = _react.useState.call(void 0, '')
  const [query, setQuery] = _react.useState.call(void 0, '')
  const [selected, setSelected] = _react.useState(_nullishCoalesce(initialFormKey, () => ( null)))
  const [picked, setPicked] = _react.useState(null)
  const [pickError, setPickError] = _react.useState.call(void 0, '')
  const [values, setValues] = _react.useState({})
  const [logMonth, setLogMonth] = _react.useState('this')
  const [editedMessage, setEditedMessage] = _react.useState(null)
  const [sending, setSending] = _react.useState.call(void 0, false)
  const [sendError, setSendError] = _react.useState.call(void 0, '')

  _react.useEffect.call(void 0, () => {
    _forms.listForms.call(void 0, { OrgKey: orgKey })
      .then(({ Forms, FirstPages }) => {
        setForms((Forms || []).filter(form => _forms.isSetTime.call(void 0, form.PublishedAt)))
        setFirstPages(FirstPages || {})
      })
      .catch(err => setListError(_forms.formsErrorText.call(void 0, err, "Couldn't load your forms. Try again.")))
  }, [orgKey])

  // Each pick reads the form and this family's last values for it; a later
  // pick wins over an earlier one still loading.
  const pickToken = _react.useRef.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    if (!selected) return
    const token = ++pickToken.current
    setPicked(null)
    setPickError('')
    setSendError('')
    setEditedMessage(null)
    Promise.all([
      _forms.getForm.call(void 0, { OrgKey: orgKey, FormKey: selected }),
      _forms.getFormSendPrefill.call(void 0, { OrgKey: orgKey, FormKey: selected, ConversationKey: conversationKey }).catch(() => null),
    ])
      .then(([{ Form }, prefill]) => {
        if (token !== pickToken.current) return
        const { values: copied, copiedNote } = _forms.sendPrefill.call(void 0, Form.Fields, prefill, recipientName)
        setValues(copied)
        setPicked({ form: Form, copiedNote })
      })
      .catch(err => {
        if (token === pickToken.current) setPickError(_forms.formsErrorText.call(void 0, err, "Couldn't open this form. Try again."))
      })
  }, [selected, orgKey, conversationKey, recipientName])

  const shown = _react.useMemo.call(void 0, () => {
    const q = query.trim().toLowerCase()
    return (forms || []).filter(form => !q || form.Name.toLowerCase().includes(q))
  }, [forms, query])

  const form = _optionalChain([picked, 'optionalAccess', _3 => _3.form])
  const log = _forms.isLogForm.call(void 0, _optionalChain([form, 'optionalAccess', _4 => _4.Fields]))
  const fields = _react.useMemo.call(void 0, () => form ? _forms.staffFields.call(void 0, form.Fields) : [], [form])
  const monthName = _forms.logMonthOf.call(void 0, logMonth).format('MMMM')
  const message = _nullishCoalesce(editedMessage, () => ( (form ? _forms.defaultFormMessage.call(void 0, form.Name, recipientName, log, logMonth) : '')))
  const missing = fields.find(field => field.required && !(values[field.id] || '').trim())

  const setValue = _react.useCallback.call(void 0, (id, value) => setValues(current => ({ ...current, [id]: value })), [])
  const valueOf = _react.useCallback.call(void 0, (field) => field.filler === 'staff' ? values[field.id] || '' : '', [values])

  const send = _react.useCallback.call(void 0, () => {
    if (!form || missing || sending) return
    setSending(true)
    setSendError('')
    _forms.sendForm.call(void 0, {
      OrgKey: orgKey,
      FormKey: form.FormKey,
      ConversationKey: conversationKey,
      Message: message.trim(),
      StaffValues: values,
      ...(log ? { LogMonth: logMonth } : {}),
    })
      .then(() => onClose())
      .catch(err => {
        setSending(false)
        setSendError(_forms.formsErrorText.call(void 0, err, "The form wasn't sent. Try again."))
      })
  }, [form, missing, sending, orgKey, conversationKey, message, values, log, logMonth, onClose])

  const goToForms = _react.useCallback.call(void 0, () => {
    onClose()
    _store.history.push('/forms')
  }, [onClose])

  const noneYet = forms !== null && forms.length === 0

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, ariaLabel: "Send a form"  , onClose: onClose, className: "forms-send", bodyClassName: "forms-send--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}
      , _react2.default.createElement('div', { className: "forms-send--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
        , _react2.default.createElement('h2', { className: "forms-send--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}, "Send a form"  )
        ,  recipientName && _react2.default.createElement('span', { className: "forms-send--to", __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}, "to " , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}, recipientName), " · secure link"   ) 
        , _react2.default.createElement('button', { type: "button", className: "forms-icon-button forms-send--close" , 'aria-label': "Close", onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}
          , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}, "close")
        )
      )
      ,  noneYet
        ? (
          _react2.default.createElement('div', { className: "forms-blank", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}
            , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}, "No published forms yet"   )
            , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}, "An org admin publishes forms before anyone can send them. Drafts wait in Forms › Library."               )
            , _react2.default.createElement(_controls.DialogButton, { onClick: goToForms, __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}}, "Go to Forms"  )
          )
          )
        : (
          _react2.default.createElement('div', { className: "forms-send--main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
            , _react2.default.createElement('div', { className: "forms-send--side", __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}
              , _react2.default.createElement('input', {
                className: "forms-input forms-send--search" ,
                type: "search",
                placeholder: "Search published forms"  ,
                'aria-label': "Search published forms"  ,
                value: query,
                onChange: e => setQuery(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
              )
              ,  listError && _react2.default.createElement('p', { className: "forms-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}, listError) 
              ,  forms === null && !listError && _react2.default.createElement('p', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}, "Loading forms…" ) 
              , _react2.default.createElement('ul', { className: "forms-send--list", 'aria-label': "Published forms" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
                ,  shown.map(item => (
                  _react2.default.createElement('li', { key: item.FormKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
                    , _react2.default.createElement('button', {
                      type: "button",
                      className: _classBuilder2.default.call(void 0, 'forms-send--item', item.FormKey === selected && 'forms-send--item-on'),
                      'aria-pressed': item.FormKey === selected,
                      onClick: () => setSelected(item.FormKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}

                      , _react2.default.createElement('span', { className: "forms-send--thumb", __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}}
                        ,  _optionalChain([firstPages, 'access', _5 => _5[item.FirstPageFileKey], 'optionalAccess', _6 => _6.URL]) && _react2.default.createElement('img', { src: firstPages[item.FirstPageFileKey].URL, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}} ) 
                      )
                      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}
                        , _react2.default.createElement('span', { className: "forms-send--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}, item.Name)
                        , _react2.default.createElement('span', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 197}}
                          , item.IsLog ? 'Log' : 'Form', " · "  , item.PageCount, " " , item.PageCount === 1 ? 'page' : 'pages'
                        )
                      )
                    )
                  )
                ))
                ,  forms !== null && forms.length > 0 && shown.length === 0 && _react2.default.createElement('li', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}, "No forms match."  ) 
              )
              ,  pickError && _react2.default.createElement('p', { className: "forms-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}, pickError) 
              ,  form && (
                _react2.default.createElement('div', { className: "forms-send--fill", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
                  ,  log && (
                    _react2.default.createElement('label', { className: "forms-send--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}, "Month"

                      , _react2.default.createElement('select', { className: "forms-input", value: logMonth, onChange: e => setLogMonth(e.target.value === 'next' ? 'next' : 'this'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}
                        , _react2.default.createElement('option', { value: "this", __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}, "This month · "   , _forms.logMonthOf.call(void 0, 'this').format('MMMM YYYY'))
                        , _react2.default.createElement('option', { value: "next", __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}, "Next month · "   , _forms.logMonthOf.call(void 0, 'next').format('MMMM YYYY'))
                      )
                    )
                  )
                  ,  fields.length > 0 && (
                    _react2.default.createElement(_react2.default.Fragment, null
                      , _react2.default.createElement('div', { className: "forms-send--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}, "You fill these before sending"    )
                      , _react2.default.createElement('div', { className: "forms-send--fields", __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}
                        ,  fields.map(field => (
                          _react2.default.createElement(FieldInput, { key: field.id, field: field, value: values[field.id] || '', onChange: setValue, __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}} )
                        ))
                      )
                      , _react2.default.createElement('p', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}}
                        , _optionalChain([picked, 'optionalAccess', _7 => _7.copiedNote]) ? `${picked.copiedNote} ` : '', "Values appear on the page as you type."
                      )
                    )
                  )
                  , _react2.default.createElement('label', { className: "forms-send--label", htmlFor: "forms-send-message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}, "Message")
                  , _react2.default.createElement('textarea', {
                    id: "forms-send-message",
                    className: "forms-input forms-send--message" ,
                    value: message,
                    onChange: e => setEditedMessage(e.target.value),
                    rows: 3, __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}
                  )
                  , _react2.default.createElement('p', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}
                    , log
                      ? `BloomText adds the link. It stays open until 14 days after ${monthName} ends.`
                      : 'BloomText adds the link. It expires in 30 days.'
                  )
                )
              )
            )
            , _react2.default.createElement('div', { className: "forms-send--preview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}
              , _react2.default.createElement('div', { className: "forms-send--pages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 248}}
                ,  form
                  ? form.Pages.map((page, i) => (
                    _react2.default.createElement(_FilledPage2.default, {
                      key: page.FileKey,
                      page: page,
                      pageIndex: i,
                      fields: form.Fields,
                      valueOf: valueOf,
                      label: `${form.Name}, page ${i + 1}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
                    )
                  ))
                  : _react2.default.createElement('p', { className: "forms-muted forms-send--hint" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}, selected && !pickError ? 'Opening the form…' : 'Pick a form to see it here.') 
              )
              , _react2.default.createElement('div', { className: "forms-send--footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 262}}
                ,  sendError && _react2.default.createElement('p', { className: "forms-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 263}}, sendError) 
                ,  !sendError && missing && _react2.default.createElement('p', { className: "forms-muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}, "Fill in "  , missing.label || 'every required field', " before sending."  ) 
                , _react2.default.createElement(_controls.DialogButton, { onClick: send, disabled: !form || !!missing, busy: sending, __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
                  , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}, "send"), " Send form"
                )
              )
            )
          )
          )
    )
  )
}

exports. default = SendFormSheet
